import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { I18nextProvider } from 'react-i18next'
import { queryClient } from 'lib/react-query'
import { Provider } from 'react-redux'
import i18n from 'config/localization/i18n'
import { store } from 'config/user/store'
import {
  ConfiguratorProvider,
  ContextProvider,
  SearchProvider,
  ChatProvider,
  TaskDetailsProvider,
  CameraControlProvider,
} from 'contexts'
import DynamicThemeProvider from 'theme/themeProvider'
import ConnectSocket from 'components/socket/ConnectSocket'
import { LowBandwidthProvider } from 'contexts/LowBandwidthContext'

export default function Providers({ children }: React.PropsWithChildren) {
  const contextProviders = [
    SearchProvider,
    ContextProvider,
    ConfiguratorProvider,
    ChatProvider,
    TaskDetailsProvider,
    CameraControlProvider,
    LowBandwidthProvider,
  ]

  const contextApiProviders = contextProviders.reduceRight(
    (acc, Provider) => <Provider>{acc}</Provider>,
    <DynamicThemeProvider>{children}</DynamicThemeProvider>
  )

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <Provider store={store}>
        <ConnectSocket />
        <I18nextProvider i18n={i18n}>{contextApiProviders}</I18nextProvider>
      </Provider>
    </QueryClientProvider>
  )
}
